const COLOR = {
  black: "#333333",
  white: "#fff",
  whiteSmoke: "#F2F2F2",
  gray: "#828282",
  green: "#27AE60",
  darkGreen: "#219653",
  lightGreen: "#6FCF97",
  greenSmoke: "#DBF3E5",
  blue: "#2F80ED",
  red: "#EB5757",
  yellow: "#F2C94C",
};

export default COLOR;
